<template>
  <div class="spinner-v">
    <div class="spinner-v__wrapper">
      <div class="spinner-v__bounce spinner-v__bounce_first" />
      <div class="spinner-v__bounce spinner-v__bounce_second" />
      <div class="spinner-v__bounce" />
    </div>
  </div>
</template>

<style lang="scss">
.spinner-v {
  z-index: 1050;
  position: fixed;
  top: 0;
  left: 0;

  display: block;
  width: 100%;
  height: 100%;

  background-color: rgba(#000, 0.4);
}

.spinner-v__wrapper {
  z-index: 10000;
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  text-align: center;
}

.spinner-v__bounce {
  display: inline-block;
  width: 18px;
  height: 18px;

  vertical-align: middle;

  background-color: #ffffff;
  border-radius: 100%;

  animation: bounce 1.4s infinite ease-in-out both;

  &_first {
    animation-delay: -0.32s;
  }

  &_second {
    animation-delay: -0.16s;
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>
